import dayjs from 'dayjs';
import { DATE_STRING_TO_MOMENT } from 'utils/date';

export const adapterBitacoraData = (bitacoraDatos) => {
  const bitacoraConFormato = bitacoraDatos;
  bitacoraConFormato.bitacora = bitacoraConFormato.bitacora.map((bitacora) => {
    return {
      ...bitacora,
      origen: bitacora?.tipoRegistro === 1 ? 'Móvil' : 'Web',
      fechaHoraFormat: bitacora?.fecha_hora
        ? dayjs(bitacora.fecha_hora.toString(), DATE_STRING_TO_MOMENT)
        : ''
    };
  });

  return adapterBitacoraData;
};
